import React from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import { Column } from '@resurs/midas-react'
import { colors } from '@resurs/midas'
import { getText } from '../../../../internal/TextLabels'
import PendingApplicationCoCustomerNotAvailable from './PendingApplicationCoCustomerNotAvailable'

const PendingApplicationCoCustomer = ({ name, governmentId }) => (
  <Conditional.Group>
    <Conditional when={name}>
      <div
        style={{
          border: '1px solid rgba(0,0,0,0.12)',
          borderTop: `3px solid ${colors.orange}`,
          background: 'white',
          margin: '1rem',
        }}
      >
        <Column col12 noPadding>
          <div style={{ padding: '2rem' }}>
            <strong>
              {getText('payApply.paymentMethod.coApplicantInfoHeader')}
            </strong>
            <div style={{ padding: '2rem 0' }}>
              <div>
                {getText('payApply.paymentMethod.coApplicantName', name)}
              </div>
              <div>
                {getText(
                  'payApply.paymentMethod.coApplicantGovernmentId',
                  governmentId,
                )}
              </div>
            </div>
            {getText(
              'payApply.paymentMethod.coApplicantInfoPendingApplication',
            )}
          </div>
        </Column>
      </div>
    </Conditional>
    <Conditional when={!name}>
      <PendingApplicationCoCustomerNotAvailable />
    </Conditional>
  </Conditional.Group>
)
PendingApplicationCoCustomer.propTypes = {
  name: PropTypes.string.isRequired,
  governmentId: PropTypes.string.isRequired,
}

export default PendingApplicationCoCustomer
